export default __webpack_public_path__ + "static/media/sleepy.0c9a99a7.png";